export default __webpack_public_path__ + "static/media/in.3bb7473f.jpg";